"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connect = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const ReducerRegistry_1 = __importDefault(require("./ReducerRegistry"));
function connect(component, config) {
    return (props) => {
        const [isInit, setIsInit] = (0, react_1.useState)(false);
        const register = () => {
            if (Array.isArray(config.reducers)) {
                config.reducers.forEach(({ name, reducer, }) => {
                    ReducerRegistry_1.default.register(name, reducer);
                });
                return;
            }
            ReducerRegistry_1.default.register(config.reducers.name, config.reducers.reducer);
        };
        const unregisterReducer = (reducerConfig) => {
            if (reducerConfig.isNeedUnregister === false) {
                return;
            }
            ReducerRegistry_1.default.unregister(reducerConfig.name);
        };
        const unregister = () => {
            if (Array.isArray(config.reducers)) {
                config.reducers.forEach((reducerConfig) => {
                    unregisterReducer(reducerConfig);
                });
                return;
            }
            unregisterReducer(config.reducers);
        };
        (0, react_1.useLayoutEffect)(() => {
            if (!config.reducers) {
                setIsInit(true);
                return undefined;
            }
            register();
            setIsInit(true);
            return () => {
                setIsInit(false);
                unregister();
            };
        }, []);
        const Component = (0, react_1.useMemo)(() => (0, react_redux_1.connect)(config.mapStateToProps, config.mapDispatchToProps)(component), []);
        if (!isInit) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, props))));
    };
}
exports.connect = connect;
